import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Alt4Footer from './Alt4Footer';
import Alt4Nav from './Alt4Nav';
import '../alt4.css';

export default function Alt4Layout({ title, children }) {
  const location = useLocation();
  const mainRef = useRef(null);

  useEffect(() => {
    const previousTitle = document.title;
    document.title = title ? `${title} | Asha` : 'Asha | AI-native PMS';
    return () => {
      document.title = previousTitle;
    };
  }, [title]);

  useEffect(() => {
    mainRef.current?.focus({ preventScroll: true });
  }, [location.pathname]);

  return (
    <div className="alt4-root">
      <a className="alt4-skip-link" href="#alt4-main">
        Skip to content
      </a>
      <Alt4Nav />
      <main id="alt4-main" ref={mainRef} tabIndex={-1}>{children}</main>
      <Alt4Footer />
    </div>
  );
}
